import { Box, Typography } from '@mui/material';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import * as Styles from './SeoReports.styles';

type SummaryData = {
  totalIssues: number;
  issuesFixedThisMonth: number;
  avgPositionChange: number;
  pagesAnalyzed: number;
};

type Props = {
  summary: SummaryData;
  isLoading: boolean;
};

const summaryCards = (summary: SummaryData) => [
  {
    label: 'Total Issues',
    value: summary.totalIssues,
    icon: BugReportOutlinedIcon,
    color: '#054AD9',
  },
  {
    label: 'Fixed This Month',
    value: summary.issuesFixedThisMonth,
    icon: CheckCircleOutlineIcon,
    color: '#2AD062',
  },
  {
    label: 'Avg Position Change',
    value: summary.avgPositionChange > 0
      ? `+${summary.avgPositionChange}`
      : String(summary.avgPositionChange),
    icon: TrendingUpIcon,
    color: summary.avgPositionChange >= 0 ? '#2AD062' : '#054AD9',
  },
  {
    label: 'Pages Analyzed',
    value: summary.pagesAnalyzed,
    icon: ArticleOutlinedIcon,
    color: '#054ad9',
  },
];

const SeoReportsComponent = function ({ summary, isLoading }: Props): JSX.Element {
  return (
    <Box sx={{}}>
      <Styles.PageHeader>
        <Styles.Title>SEO Reports</Styles.Title>
      </Styles.PageHeader>

      <Styles.Grid>
        {summaryCards(summary).map((card) => {
          const Icon = card.icon;
          return (
            <Styles.Card key={card.label}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
                <Icon sx={{ color: card.color, fontSize: 24 }} />
                <Typography variant="caption" color="text.secondary">
                  {card.label}
                </Typography>
              </Box>
              <Typography variant="h4" fontWeight={700}>
                {isLoading ? '—' : card.value}
              </Typography>
            </Styles.Card>
          );
        })}
      </Styles.Grid>

      <Styles.ChartCard>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
          Health Score Trend
        </Typography>
        <Box sx={{ height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Chart will render here once audit data is available.
          </Typography>
        </Box>
      </Styles.ChartCard>

      <Styles.ChartCard>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
          Keyword Position Distribution
        </Typography>
        <Box sx={{ height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Chart will render here once keyword data is available.
          </Typography>
        </Box>
      </Styles.ChartCard>
    </Box>
  );
};

export default SeoReportsComponent;
